// 签单 - 合作商
import request from '@/tool/request'
const c = 'SignAdmin/';

// 签单系统设置 - 获取数据
export function getSysSet(query) {
  return request({
    url: c+'getSysSet',
    method: 'post',
    data:query
  })
}
// 签单系统设置 - 设置
export function sysSet(query) {
  return request({
    url: c+'sysSet',
    method: 'post',
    data:query
  })
}
// 充值列表
export function rechargeList(query) {
  return request({
    url: c+'rechargeList',
    method: 'post',
    data:query
  })
}
// 充值审核
export function rechargeSh(query) {
  return request({
    url: c+'rechargeSh',
    method: 'post',
    data:query
  })
}

// 签单余额记录
export function brList(query) {
  return request({
    url: c+'brList',
    method: 'post',
    data:query
  })
}

// 获取excel导出的token
export function excelToken(query) {
  return request({
    url: c+'excelToken',
    method: 'post',
    data:query
  })
}

// 余额调整
export function moneyChange(query) {
  return request({
    url: c+'moneyChange',
    method: 'post',
    data:query
  })
}

/********************************* 平台 *********************************/
// 列表
export function platformList(query) {
  return request({
    url: c+'platformList',
    method: 'post',
    data:query
  })
}
// 添加/编辑
export function platformSet(query) {
  return request({
    url: c+'platformSet',
    method: 'post',
    data:query
  })
}
// 删除
export function platformDel(query) {
  return request({
    url: c+'platformDel',
    method: 'post',
    data:query
  })
}

/********************************* 国家设置 *********************************/
// 列表
export function countryList(query) {
  return request({
    url: c+'countryList',
    method: 'post',
    data:query
  })
}
// 添加/编辑
export function countrySet(query) {
  return request({
    url: c+'countrySet',
    method: 'post',
    data:query
  })
}
// 删除
export function countryDel(query) {
  return request({
    url: c+'countryDel',
    method: 'post',
    data:query
  })
}

/********************************* 特殊佣金设置 *********************************/
// 列表
export function commissionList(query) {
  return request({
    url: c+'commissionList',
    method: 'post',
    data:query
  })
}
// 添加/编辑
export function commissionSet(query) {
  return request({
    url: c+'commissionSet',
    method: 'post',
    data:query
  })
}
// 添加/编辑
export function commissionDel(query) {
  return request({
    url: c+'commissionDel',
    method: 'post',
    data:query
  })
}

/********************************* 订单列表 *********************************/
// 列表
export function orderList(query) {
  return request({
    url: c+'orderList',
    method: 'post',
    data:query
  })
}
// 获取面单打印的token
export function shippinglabelToken(query) {
  return request({
    url: c+'shippinglabelToken',
    method: 'post',
    data:query
  })
}
// 打印标记
export function printMark(query) {
  return request({
    url: c+'printMark',
    method: 'post',
    data:query
  })
}
// 操作记录
export function orderLog(query) {
  return request({
    url: c+'orderLog',
    method: 'post',
    data:query
  })
}
// 发货
export function orderSend(query) {
  return request({
    url: c+'orderSend',
    method: 'post',
    data:query
  })
}
// 取消
export function orderCancel(query) {
  return request({
    url: c+'orderCancel',
    method: 'post',
    data:query
  })
}
// 标识的修改
export function orderflag(query) {
  return request({
    url: c+'orderflag',
    method: 'post',
    data:query
  })
}
// 备注的修改
export function orderRemarks(query) {
  return request({
    url: c+'orderRemarks',
    method: 'post',
    data:query
  })
}

/********************************* 订单签收列表 *********************************/
// 列表（只显示已签收的）
export function orderSignList(query) {
  return request({
    url: c+'orderSignList',
    method: 'post',
    data:query
  })
}
// 获取订单详情
export function getOrder(query) {
  return request({
    url: c+'getOrder',
    method: 'post',
    data:query
  })
}
// 签收提交
export function signUp(query) {
  return request({
    url: c+'signUp',
    method: 'post',
    data:query
  })
}
// 签收提交 - 批量
export function signUpBatch(query) {
  return request({
    url: c+'signUpBatch',
    method: 'post',
    data:query,
	timeout: 0, // 这个接口设置不超时
  })
}

/********************************* 角色 *********************************/
// 添加/编辑
export function roleSet(query) {
  return request({
    url: c+'roleSet',
    method: 'post',
    data:query
  })
}
// 列表
export function roleList(query) {
  return request({
    url: c+'roleList',
    method: 'post',
    data:query
  })
}
// 下拉框使用
export function getRoles(query) {
  return request({
    url: c+'getRoles',
    method: 'post',
    data:query
  })
}
// 删除
export function roleDel(query) {
  return request({
    url: c+'roleDel',
    method: 'post',
    data:query
  })
}

/********************************* 用户 *********************************/
// 列表
export function managerList(query) {
  return request({
    url: c+'managerList',
    method: 'post',
    data:query
  })
}
// 添加/编辑
export function managerSet(query) {
  return request({
    url: c+'managerSet',
    method: 'post',
    data:query
  })
}
// 删除
export function managerDel(query) {
  return request({
    url: c+'managerDel',
    method: 'post',
    data:query
  })
}
// 获取用户（仓库和合作商）
export function getPartnerList(query) {
  return request({
    url: c+'getPartnerList',
    method: 'post',
    data:query
  })
}
// 余额检测
export function moneyCheck(query) {
  return request({
    url: c+'moneyCheck',
    method: 'post',
    data:query
  })
}

/********************************* 推荐人 *********************************/
// 抽成记录
export function reMoneyList(query) {
  return request({
    url: c+'reMoneyList',
    method: 'post',
    data:query
  })
}

/********************************* 提现账号设置 *********************************/
// 列表
export function accountList(query) {
  return request({
    url: c+'accountList',
    method: 'post',
    data:query
  })
}
// 添加/编辑
export function accountSet(query) {
  return request({
    url: c+'accountSet',
    method: 'post',
    data:query
  })
}
// 删除
export function accountDel(query) {
  return request({
    url: c+'accountDel',
    method: 'post',
    data:query
  })
}

/********************************* 提现 *********************************/
// 提现列表
export function withdrawalList(query) {
  return request({
    url: c+'withdrawalList',
    method: 'post',
    data:query
  })
}
// 提现
export function withdrawal(query) {
  return request({
    url: c+'withdrawal',
    method: 'post',
    data:query
  })
}

/********************************* 提现审核 *********************************/
// 列表
export function withdrawaShlList(query) {
  return request({
    url: c+'withdrawaShlList',
    method: 'post',
    data:query
  })
}
// 审核
export function withdrawalSh(query) {
  return request({
    url: c+'withdrawalSh',
    method: 'post',
    data:query
  })
}

/********************************* 充值/扣款 *********************************/
// 提交
export function rk(query) {
  return request({
    url: c+'rk',
    method: 'post',
    data:query
  })
}
// 列表
export function rkList(query) {
  return request({
    url: c+'rkList',
    method: 'post',
    data:query
  })
}

// 每日统计 - 列表
export function dayTotal(query) {
  return request({
    url: c+'dayTotal',
    method: 'post',
    data:query
  })
}